(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
(function () {
  var bar = document.querySelector('[data-jb-ab]');
  if (!bar) return;
  var ship = bar.querySelector('[data-jb-ab-ship]');
  var pills = bar.querySelector('[data-jb-ab-pills]');
  if (!ship || !pills) return;

  var enabled = bar.dataset.jbShipEnabled === 'true';
  var isUS = bar.dataset.jbShipUs === 'true';
  var threshold = parseInt(bar.dataset.jbShipThreshold || '0', 10);
  if (!enabled || !isUS || threshold <= 0) return;

  var msgEl = ship.querySelector('[data-jb-ab-ship-msg]');
  var fillEl = ship.querySelector('[data-jb-ab-ship-fill]');

  function money(cents) {
    var d = Math.max(0, cents) / 100;
    return '$' + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2));
  }

  function render(cart) {
    if (!cart || typeof cart.item_count === 'undefined') return;
    if (cart.item_count > 0) {
      var total = cart.total_price;
      fillEl.style.width = Math.min(100, (total / threshold) * 100) + '%';
      if (total >= threshold) {
        msgEl.textContent = "🎉 You've unlocked free U.S. shipping!";
      } else {
        msgEl.textContent = "🚚 You're " + money(threshold - total) + " away from free U.S. shipping";
      }
      pills.hidden = true;
      ship.hidden = false;
    } else {
      ship.hidden = true;
      pills.hidden = false;
    }
  }

  var debounce = null;
  function sync() {
    clearTimeout(debounce);
    debounce = setTimeout(function () {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () {});
    }, 60);
  }

  sync();

  document.addEventListener('cart:updated', function (e) {
    if (e && e.detail && typeof e.detail.item_count !== 'undefined') {
      render(e.detail);
    } else {
      sync();
    }
  });

  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input) {
      var result = nativeFetch.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/(add|change|update|clear)/i.test(url)) {
          result.then(function () { sync(); }).catch(function () {});
        }
      } catch (err) {}
      return result;
    };
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom_popup"]) return;
  try {
    
	
jQuery(document).ready(function() {
    var check_cookie = getCookie('newsletter_popup');
    if(window.location!=window.parent.location) {
        jQuery('#newsletter_popup').remove();
    } else {
        if(check_cookie == null || check_cookie == 'shown') {
            //jQuery.cookie('newsletter_popup', true, {expires: 1});
            document.cookie = "newsletter_popup=true;max-age=8600";
            setTimeout(function(){
                beginNewsletterForm();
            }, 3000);
        }
        jQuery('#newsletter_popup_dont_show_again').on('change', function() {
            if(jQuery(this).length){
                var check_cookie = jQuery.cookie('newsletter_popup');
                if(check_cookie == null || check_cookie == 'shown') {
                    //jQuery.cookie('newsletter_popup','dontshowitagain');
                    document.cookie = "newsletter_popup=dontshowitagain";
                }
                else
                {
                    //jQuery.cookie('newsletter_popup','shown');
                    document.cookie = "newsletter_popup=shown";
                    beginNewsletterForm();
                }
            } else {
                //jQuery.cookie('newsletter_popup','shown');
                document.cookie = "newsletter_popup=shown";
            }
        });
    }

    jQuery('.popup-close').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        jQuery('[data-popup="popup-1"]').fadeOut(350);
        return;
    });

    jQuery('.mypopup').on('click', function(e) {
        e.preventDefault();
        jQuery('[data-popup="popup-1"]').fadeOut(350);
    });

    jQuery('.popup-inner').on('click', function() {
        bannerURL = jQuery('.mypopup_link').attr("href");
        window.open(bannerURL, '_blank');
    });

    function beginNewsletterForm() {
        imageWidth = $('#myPopupImage').data("imagewidth");
        imageHeight = $('#myPopupImage').data("imageheight");

        $('.popup-inner').css({'max-width' : imageWidth + 'px', 'max-height' : imageHeight + 'px'});

        $('[data-popup="popup-1"]').fadeIn(350);
    }

    function getCookie(name) {
        let value = `; ${document.cookie}`;
        let parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jb-also-loved"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.jb-also').forEach(function (root) {
    if (root.dataset.jbBound) return;
    root.dataset.jbBound = '1';
    root.querySelectorAll('form[data-jb-atc]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('button');
        if (btn.disabled) return;
        var orig = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        }).then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:open'));
            btn.textContent = 'Added ✓';
            setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1400);
          })
          .catch(function () {
            btn.textContent = 'Try again';
            setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1400);
          });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jb-best-sellers"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.jb-best').forEach(function (root) {
    if (root.dataset.jbBound) return;
    root.dataset.jbBound = '1';
    var tabs = root.querySelectorAll('.jb-tab');
    var panels = root.querySelectorAll('.jb-best__panel');
    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-tab-target');
        tabs.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          var on = p.id === target;
          p.classList.toggle('is-active', on);
          p.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
      });
    });

    // AJAX add-to-cart → open the side cart drawer
    root.querySelectorAll('form[data-jb-atc]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('button');
        if (btn.disabled) return;
        var originalText = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding…';
        var fd = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        }).then(function () {
          document.dispatchEvent(new CustomEvent('cart:open'));
          btn.textContent = 'Added ✓';
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1400);
        }).catch(function () {
          btn.textContent = 'Try again';
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1400);
        });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jb-cart-drawer"]) return;
  try {
    
(function () {
  var drawer = document.querySelector('[data-jb-drawer]');
  if (!drawer) return;
  var cart = null;
  var timerInt = null;
  var reserveSecRemaining = 0;
  var showReserve = drawer.dataset.showReserve === 'true';
  var showProgress = drawer.dataset.showProgress === 'true';
  var reserveMin = parseInt(drawer.dataset.reserveMin || '8', 10);
  var tiers = [];
  ['1','2','3'].forEach(function (n) {
    var amt = parseFloat(drawer.dataset['t' + n + 'Amt'] || '0');
    var lbl = drawer.dataset['t' + n + 'Lbl'] || '';
    if (amt > 0) tiers.push({ amount: amt, label: lbl });
  });

  function $(sel, root) { return (root || drawer).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || drawer).querySelectorAll(sel)); }

  function fmt(cents) {
    var n = (cents / 100);
    var sign = n < 0 ? '-' : '';
    n = Math.abs(n);
    return sign + '$' + n.toFixed(2);
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function open() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    refresh();
    if (showReserve) startTimer();
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    stopTimer();
  }

  $$('[data-jb-drawer-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  // Intercept clicks on header cart icon → open drawer instead of navigate
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    var clean = href.split('?')[0].replace(/\/+$/, '');
    if (clean === '/cart' || clean.endsWith('/cart')) {
      if (clean === '/cart' || /^\/[a-z-]+\/cart$/i.test(clean)) {
        e.preventDefault();
        open();
      }
    }
  });

  document.addEventListener('cart:open', open);
  document.addEventListener('cart:refresh', refresh);

  function refresh() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        cart = data;
        render();
        loadRecs();
      });
  }

  function render() {
    $('[data-jb-count]').textContent = cart.item_count;
    var items = $('[data-jb-items]');
    var foot = $('[data-jb-foot]');
    var prog = $('[data-jb-progress]');
    if (showReserve) $('[data-jb-reserve]').hidden = cart.item_count === 0;

    if (!cart.items || cart.items.length === 0) {
      items.innerHTML = '<div class="jb-cd__empty">Your cart is empty.</div>';
      foot.hidden = true;
      if (prog) prog.hidden = true;
      if (showReserve) $('[data-jb-reserve]').hidden = true;
      var love = $('[data-jb-love]');
      if (love) love.hidden = true;
      prevDone = false;
      return;
    }
    foot.hidden = false;
    if (showProgress && prog) prog.hidden = false;
    items.innerHTML = cart.items.map(function (it) {
      var img = it.image ? (it.image.replace(/_(\d+x)?\./, '_200x.')) : '';
      return [
        '<div class="jb-cd__item" data-key="' + escapeHtml(it.key) + '">',
        img ? '<img class="jb-cd__item-img" src="' + escapeHtml(img) + '" alt="' + escapeHtml(it.product_title) + '" />' : '<div class="jb-cd__item-img"></div>',
        '<a href="' + escapeHtml(it.url) + '" class="jb-cd__item-title">' + escapeHtml(it.product_title) + '</a>',
        '<button class="jb-cd__item-remove" data-remove aria-label="Remove">',
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path><path d="M10 11v6"></path><path d="M14 11v6"></path><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"></path></svg>',
        '</button>',
        '<div class="jb-cd__item-qty">',
          '<button class="jb-cd__qty-btn" data-qty-down aria-label="Decrease">−</button>',
          '<input class="jb-cd__qty-input" type="number" value="' + it.quantity + '" min="0" data-qty-input>',
          '<button class="jb-cd__qty-btn" data-qty-up aria-label="Increase">+</button>',
        '</div>',
        '<div class="jb-cd__item-price">' + fmt(it.final_line_price) + '</div>',
        '</div>'
      ].join('');
    }).join('');
    bindItems();
    $('[data-jb-subtotal]').textContent = fmt(cart.total_price);
    $('[data-jb-checkout-total]').textContent = fmt(cart.total_price);
    updateProgress();
  }

  function bindItems() {
    $$('.jb-cd__item').forEach(function (row) {
      var key = row.dataset.key;
      var input = row.querySelector('[data-qty-input]');
      row.querySelector('[data-qty-down]').addEventListener('click', function () {
        change(key, Math.max(0, parseInt(input.value, 10) - 1));
      });
      row.querySelector('[data-qty-up]').addEventListener('click', function () {
        change(key, parseInt(input.value, 10) + 1);
      });
      input.addEventListener('change', function () {
        var v = parseInt(input.value, 10);
        if (isNaN(v) || v < 0) v = 0;
        change(key, v);
      });
      row.querySelector('[data-remove]').addEventListener('click', function () {
        change(key, 0);
      });
    });
  }

  function change(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (data) {
        cart = data;
        render();
        loadRecs();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      });
  }

  // Free shipping bar: same copy, fill animation, pop and confetti as the product page bar
  var prevDone = null;
  function money(n) { return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2)); }
  function celebrate(el, confetti) {
    el.classList.remove('is-pop'); void el.offsetWidth; el.classList.add('is-pop');
    if (!confetti) return;
    var cols = ['#e23b3b', '#d4a84a', '#2e7df6', '#22b35e', '#ff7ac2', '#0e0c14'];
    for (var i = 0; i < 26; i++) {
      var s = document.createElement('span');
      s.className = 'jb-cd__conf';
      var a = Math.random() * Math.PI * 2, dist = 60 + Math.random() * 90;
      s.style.setProperty('--x', Math.cos(a) * dist * 1.6 + 'px');
      s.style.setProperty('--y', Math.sin(a) * dist - 30 + 'px');
      s.style.setProperty('--r', (Math.random() * 720 - 360) + 'deg');
      s.style.background = cols[i % cols.length];
      s.style.animationDelay = Math.random() * 80 + 'ms';
      el.appendChild(s);
      setTimeout(function (x) { x.remove(); }, 1400, s);
    }
  }
  function updateProgress() {
    if (!showProgress || tiers.length === 0) return;
    var box = $('[data-jb-progress]');
    var msg = $('[data-jb-progress-msg]');
    var track = $('[data-jb-progress-track]');
    var fill = $('[data-jb-progress-fill]');
    if (!box || !msg || !fill) return;
    var t = tiers[0].amount;
    var lbl = (tiers[0].label || 'Free shipping').toLowerCase();
    var total = cart.total_price / 100;
    var done = total >= t;
    if (!done) {
      msg.innerHTML = 'You are <strong>' + money(t - total) + '</strong> away from ' + escapeHtml(lbl) + ' on this order';
      track.hidden = false;
      var pct = Math.max(4, Math.min(100, total / t * 100));
      requestAnimationFrame(function () { requestAnimationFrame(function () { fill.style.width = pct + '%'; }); });
    } else {
      msg.innerHTML = 'You unlocked ' + escapeHtml(lbl) + ' on this order 🎉';
      track.hidden = true;
      fill.style.width = '100%';
    }
    box.classList.toggle('is-done', done);
    if (done && prevDone === false) celebrate(box, true);
    else if (done && prevDone === null) celebrate(box, false);
    prevDone = done;
  }

  function loadRecs() {
    var love = $('[data-jb-love]');
    if (!love) return;
    if (!cart.items || cart.items.length === 0) { love.hidden = true; return; }
    var pid = cart.items[0].product_id;
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=related', {
      headers: { 'Accept': 'application/json' }
    }).then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data && data.products) || [];
        // filter out anything already in cart or unavailable
        var inCart = (cart.items || []).map(function (i) { return i.product_id; });
        products = products.filter(function (p) { return inCart.indexOf(p.id) === -1 && p.available !== false; });
        if (products.length === 0) { love.hidden = true; return; }
        renderRecs(products.slice(0, 3));
        love.hidden = false;
      }).catch(function () { love.hidden = true; });
  }

  function renderRecs(products) {
    var track = $('[data-jb-love-track]');
    track.innerHTML = products.map(function (p) {
      var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?.*)?$/i, '_300x$1$2') : '';
      var vars = p.variants || [];
      var v = vars.filter(function (x) { return x.available; })[0] || vars[0];
      var single = vars.length <= 1;
      var btn = single && v
        ? '<button type="button" class="jb-cd__rec-add" data-rec-add data-variant-id="' + escapeHtml(v.id) + '">+ Add</button>'
        : '<a class="jb-cd__rec-add" href="' + escapeHtml(p.url) + '">Options</a>';
      return [
        '<div class="jb-cd__rec">',
          '<a href="' + escapeHtml(p.url) + '" class="jb-cd__rec-link">',
            img ? '<img class="jb-cd__rec-img" src="' + escapeHtml(img) + '" alt="' + escapeHtml(p.title) + '" loading="lazy" />' : '<div class="jb-cd__rec-img"></div>',
            '<span class="jb-cd__rec-title">' + escapeHtml(p.title) + '</span>',
          '</a>',
          '<span class="jb-cd__rec-price">' + fmt(p.price) + '</span>',
          btn,
        '</div>'
      ].join('');
    }).join('');
    $$('[data-rec-add]', track).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var vid = btn.dataset.variantId;
        if (!vid) return;
        btn.disabled = true;
        var original = btn.textContent;
        btn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: vid, quantity: 1 })
        }).then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
          .then(function () {
            btn.textContent = 'Added ✓';
            return refresh();
          }).catch(function () {
            btn.textContent = original;
            btn.disabled = false;
          });
      });
    });
  }

  function startTimer() {
    if (timerInt) return;
    if (!reserveSecRemaining) reserveSecRemaining = reserveMin * 60;
    var el = $('[data-jb-timer]');
    var tick = function () {
      var m = Math.floor(reserveSecRemaining / 60);
      var s = reserveSecRemaining % 60;
      if (el) el.textContent = m + ':' + (s < 10 ? '0' + s : s);
      reserveSecRemaining--;
      if (reserveSecRemaining < 0) stopTimer();
    };
    tick();
    timerInt = setInterval(tick, 1000);
  }
  function stopTimer() {
    if (timerInt) { clearInterval(timerInt); timerInt = null; }
  }

  // Keep the header cart-count badge live-synced on every cart change
  function jbSyncCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-js-cart-count]').forEach(function (el) {
          el.textContent = c.item_count;
        });
      })
      .catch(function () {});
  }
  jbSyncCartCount();
  document.addEventListener('cart:updated', jbSyncCartCount);
  var jbNativeFetch = window.fetch;
  if (typeof jbNativeFetch === 'function') {
    window.fetch = function (input) {
      var ret = jbNativeFetch.apply(this, arguments);
      try {
        var u = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/(add|change|update|clear)/i.test(u)) {
          ret.then(function () { setTimeout(jbSyncCartCount, 60); }).catch(function () {});
        }
      } catch (e) {}
      return ret;
    };
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jb-category-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.jb-cat-tabs').forEach(function (root) {
    if (root.dataset.jbBound) return;
    root.dataset.jbBound = '1';

    var targetSectionId = root.dataset.targetSection || 'product-grid';
    var sectionWrapperId = 'shopify-section-' + targetSectionId;
    var loading = false;

    root.addEventListener('click', function (e) {
      var tab = e.target.closest('.jb-cat-tabs__tab');
      if (!tab || loading) return;

      var url = tab.dataset.tabUrl;
      if (!url) return;

      // Let modifier-clicks and middle-clicks behave like normal links
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;

      e.preventDefault();

      var wrapper = document.getElementById(sectionWrapperId);
      if (!wrapper) {
        // No swappable section on page — fall back to navigation
        window.location.href = url;
        return;
      }

      loading = true;
      // Visual hint
      wrapper.style.opacity = '0.4';
      wrapper.style.pointerEvents = 'none';

      // Use Shopify Section Rendering API
      var fetchUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + 'sections=' + encodeURIComponent(targetSectionId);

      fetch(fetchUrl, { headers: { 'Accept': 'application/json' } })
        .then(function (r) {
          if (!r.ok) throw new Error('section fetch failed');
          return r.json();
        })
        .then(function (data) {
          var html = data[targetSectionId];
          if (!html) throw new Error('section html missing');
          // The returned HTML is the inner contents of the wrapper, not the wrapper itself
          wrapper.innerHTML = html;
          wrapper.style.opacity = '';
          wrapper.style.pointerEvents = '';

          // Update active tab state
          root.querySelectorAll('.jb-cat-tabs__tab').forEach(function (t) {
            var active = t === tab;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-selected', active ? 'true' : 'false');
          });

          // Update URL without navigating
          if (window.history && window.history.pushState) {
            window.history.pushState({ jbTab: true }, '', url);
          }

          // Scroll target into view (gentle)
          var top = wrapper.getBoundingClientRect().top + window.pageYOffset - 80;
          window.scrollTo({ top: top, behavior: 'smooth' });

          // Let other scripts re-hydrate the grid
          document.dispatchEvent(new CustomEvent('jb:section-swapped', { detail: { sectionId: targetSectionId } }));
        })
        .catch(function () {
          // Fall back to a real navigation
          window.location.href = url;
        })
        .finally(function () {
          loading = false;
        });
    });

    // Handle back/forward — reload the page so URL state matches
    window.addEventListener('popstate', function (e) {
      if (e.state && e.state.jbTab) {
        window.location.reload();
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jb-collection-grid"]) return;
  try {
    
(function () {
  document.querySelectorAll('.jb-coll').forEach(function (root) {
    if (root.dataset.jbBound) return;
    root.dataset.jbBound = '1';
    root.querySelectorAll('form[data-jb-atc]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('button');
        if (btn.disabled) return;
        var originalText = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding…';
        var fd = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        }).then(function () {
          document.dispatchEvent(new CustomEvent('cart:open'));
          btn.textContent = 'Added ✓';
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1400);
        }).catch(function () {
          btn.textContent = 'Try again';
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1400);
        });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jb-reels"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.jb-reels').forEach(function (root) {
    if (root.dataset.jbBound) return;
    root.dataset.jbBound = '1';

    var track = root.querySelector('[data-jb-reels-track]');
    var prev = root.querySelector('[data-jb-reels-prev]');
    var next = root.querySelector('[data-jb-reels-next]');

    function scrollStep(dir) {
      if (!track) return;
      var card = track.querySelector('.jb-reels__card');
      var w = card ? card.getBoundingClientRect().width + 16 : 280;
      track.scrollBy({ left: dir * w * 2, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { scrollStep(-1); });
    if (next) next.addEventListener('click', function () { scrollStep(1); });

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-jb-reel-play]');
      if (!btn) return;
      var card = btn.closest('.jb-reels__card');
      var video = card && card.querySelector('video[data-jb-reel-video]');
      if (!video) return;

      root.querySelectorAll('video[data-jb-reel-video]').forEach(function (v) {
        if (v !== video && !v.paused) {
          v.pause();
          var c = v.closest('.jb-reels__card');
          if (c) c.classList.remove('is-playing');
        }
      });

      if (video.paused) {
        var p = video.play();
        if (p && typeof p.then === 'function') {
          p.then(function () { card.classList.add('is-playing'); }).catch(function () {});
        } else {
          card.classList.add('is-playing');
        }
      } else {
        video.pause();
        card.classList.remove('is-playing');
      }
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            var v = entry.target.querySelector('video[data-jb-reel-video]');
            if (v && !v.paused) {
              v.pause();
              entry.target.classList.remove('is-playing');
            }
          }
        });
      }, { threshold: 0.25 });
      root.querySelectorAll('.jb-reels__card').forEach(function (c) { io.observe(c); });
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
